// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. IMPORTANT. Refactor all that shit.
// I don't like it anymore.
// SOLUTION. MOVE TO INOTIFYPROPERTYCHANGED PATTERN LIKE IN C# MVVM.
//
// There should be some sort of DEPENDENCY LOGIC BETWEEN ORDEREDIT'S PARAMETERS AND TRADINGDATA.
// IMPORTANT. Make "Trading Data" fields (instrument, account, quote, side, etc)
// become dynamic parameters of OrderEdit object,
// for instance like "limit price", "stop price" in StopLimitOrderEdit.
// (refactor it, i don't like logic of setTradingData(), updateParameters()).
//
// IMPORTANT. Come up with methods for quick assigning parameter's value
// without going through all that updateParameters() shit.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HistoryType } from '@shared/utils/History/HistoryType';
import { Intervals } from '@shared/utils/Instruments/Intervals';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { Account } from '../../../../Commons/cache/Account';
import { MathUtils } from '@shared/utils/MathUtils';
import { NumericUtils } from '@shared/utils/NumericUtils';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { IsAllowed } from '../../../IsAllowed';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { OrderEditRequestData } from '@shared/utils/Trading/OrderEditRequestData';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { PositionSizingEdit } from '../PositionSizingEdit';
import { OrderEditConfirmationTextParams } from '../OrderEditConfirmationTextParams';
import { OrderExecutorUtils } from '../../../Trading/OrderExecutorUtils';
import { DynProperty } from '../../../DynProperty';
import { BaseSettings } from '../../../Settings/BaseGeneralSettingsWrapper';
import { OrderWarningsManager } from './OrderWarningsManager';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { getConfirmationMarginInfoAsync } from '../../../UtilsClasses/MarginInfo/ConfirmationMarginInfo';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
// TODO. Use DynProperty.sortIndex for ordering.
// TODO. Throw exception (or something)
// if there's insufficient data for creating an order request:
// instrument, quote and whatnot is missing, for instance.
export class OrderEditBase {
    get instrument() {
        return this._instrument;
    }
    set instrument(value) {
        if (this._instrument === value) {
            return;
        }
        this.unsubscribeQuotes(this._instrument);
        this._instrument = value;
        this.sltp.instrument = value;
        this.subscribeQuotes(this._instrument);
    }
    get isDisposed() {
        return this._disposed;
    }
    getLastMarginResponse() {
        return this.lastMarginResponse;
    }
    constructor(data) {
        this._disposed = false;
        this._instrument = null;
        this.account = null;
        this.side = null;
        this.tif = null;
        this.quantity = null;
        this.disclosedQuantity = null;
        this.quote = null;
        this.placedFrom = null;
        this.sltp = null;
        this.productType = null;
        this.leverageValue = null;
        this.customCSS = null;
        this.hasAnySMFlagsWarning = false; // Surveillance Measure warning #114474
        this.hasWarnOnIdenticalOrder = false; // для метода needToShowWarningForcefully сохраняем есть ли у текущего ордера предупреждение об идентичности  (#110331)
        this.previousOrderJSON = null; // #94309
        this.previousOrderDate = null; // value of last order's Date.now() (ticks)
        this.orderEditValid = null;
        this.skipSessionSettingsChanged = false;
        this.AlerEdit = false;
        this.comment = null;
        this.limitPrice = null;
        this.stopPrice = null;
        this.trailingStop = null;
        this.order = null;
        this.position = null;
        this.totalFee = null;
        this.estAvailableCash = null;
        this.cash = null;
        this.estQtyValue = null; // P/L for SL\TP controls should be calculated with Est.Quantity received from server #122525
        this.isCashQtyMode = false;
        this.userComment = '';
        this.isAllowOTHTrading = null;
        this.positionSizing = new PositionSizingEdit();
        this.parameterNameArray = this.getParameterNameArray();
        this.parameterNameSet = this.getParameterNameSet();
        this.parameterUpdateHandlerDict = this.initParameterUpdateHandlerDict();
        this.parameterDynPropertyGeneratorDict = this.initParameterDynPropertyGeneratorDict();
        this.parameterRawValueGeneratorDict = this.initParameterRawValueGeneratorDict();
        this.errorDict = {}; // <parameter_name:error>
        this.warningsManager = new OrderWarningsManager(this);
        this.sessionSettings = BaseSettings;
        BaseSettings.settingsChanged.Subscribe(this.sessionSettingsChanged, this);
        this.quoteCache = data.dataCache.FQuoteCache;
        this.ParametersChanged = new CustomEvent();
        this.ValidStateChanged = new CustomEvent();
        this.QuantityChanged = new CustomEvent();
        TradingLockUtils.TradingLock.TradingLockChanged.Subscribe(this.tryUpdateValidState, this);
        Account.TradeStatusChanged.Subscribe(this.tryUpdateValidState, this);
    }
    static isDisclosedQuantityNeed(ins, orderType, tif) {
        const t = ins === null || ins === void 0 ? void 0 : ins.InstrType;
        const allTypes = InstrumentTypes;
        const insSuitable = t === allTypes.EQUITIES || // #87051
            ((ins === null || ins === void 0 ? void 0 : ins.TradingExchange) === 'MCX' &&
                (t === allTypes.FUTURES || t === allTypes.CFD_FUTURES || t === allTypes.OPTIONS)); // #107847
        const orderTypes = OrderType;
        const orderTypeSuitable = orderType === orderTypes.Market || orderType === orderTypes.Limit;
        const orderTifSuitable = tif.type === OrderTif.Day;
        return insSuitable && orderTypeSuitable && orderTifSuitable;
    }
    // TODO. Remove?
    setBasePrice(price, isLimitModify = null, noNeedToSetDefaultOffset = null) { }
    // TODO. Remove?
    getBasePrice() { }
    dispose() {
        this._disposed = true;
        BaseSettings.settingsChanged.UnSubscribe(this.sessionSettingsChanged, this);
        this.sessionSettings = null;
        TradingLockUtils.TradingLock.TradingLockChanged.UnSubscribe(this.tryUpdateValidState, this);
        Account.TradeStatusChanged.UnSubscribe(this.tryUpdateValidState, this);
        this.instrument = null;
        this.quoteCache = null;
        this.errorDict = null;
        this.account = null;
        this.quote = null;
        this.side = null;
        this.tif = null;
        this.quantity = null;
        this.cash = null;
        this.comment = null;
        this.totalFee = null;
        this.estAvailableCash = null;
        this.warningsManager = null;
        this.userComment = null;
        this.isAllowOTHTrading = null;
    }
    initParameterUpdateHandlerDict() {
        const resDict = {};
        for (const paramName in this.parameterNameSet) {
            const handlerFunctionName = 'update_' + paramName;
            const handler = this[handlerFunctionName];
            if (typeof handler !== 'function') {
                throw new Error(handlerFunctionName + ' function is not implemented.');
            }
            resDict[paramName] = handler;
        }
        return resDict;
    }
    initParameterDynPropertyGeneratorDict() {
        const resDict = {};
        for (const paramName in this.parameterNameSet) {
            const handlerFunctionName = 'toDynProperty_' + paramName;
            const handler = this[handlerFunctionName];
            if (typeof handler !== 'function') {
                throw new Error(handlerFunctionName + ' function is not implemented.');
            }
            resDict[paramName] = handler;
        }
        return resDict;
    }
    initParameterRawValueGeneratorDict() {
        const resDict = {};
        for (const paramName in this.parameterNameSet) {
            const handlerFunctionName = 'toRawValue_' + paramName;
            const handler = this[handlerFunctionName];
            if (typeof handler !== 'function') {
                throw new Error(handlerFunctionName + ' function is not implemented.');
            }
            resDict[paramName] = handler;
        }
        return resDict;
    }
    // TODO. IMPORTANT. Refactor. setTradingData() - i don't like it.
    // Sets External data for trading (Instrument, account, etc).
    // Returns updated fields in a dictionary.
    setTradingData(tradingDataDict) {
        var _a, _b;
        if (!tradingDataDict)
            return null;
        const newTradingDataDict = {};
        let updated = false;
        // TODO. Refactor. Details are at the top of the file.
        if ('instrument' in tradingDataDict) {
            this.instrument = tradingDataDict.instrument;
            this.quote = ((_a = this.instrument) === null || _a === void 0 ? void 0 : _a.LastQuote) || ((_b = this.instrument) === null || _b === void 0 ? void 0 : _b.LastInvalidQuote);
            newTradingDataDict.instrument = this.instrument;
            newTradingDataDict.quote = this.quote;
            updated = true;
        }
        // TODO. Refactor. Details are at the top of the file.
        if ('quote' in tradingDataDict) {
            this.quote = tradingDataDict.quote;
            newTradingDataDict.quote = this.quote;
            updated = true;
        }
        if ('account' in tradingDataDict) {
            this.account = tradingDataDict.account;
            newTradingDataDict.account = this.account;
            updated = true;
        }
        if ('side' in tradingDataDict) {
            this.side = tradingDataDict.side;
            newTradingDataDict.side = this.side;
            updated = true;
        }
        if ('tif' in tradingDataDict) {
            this.tif = tradingDataDict.tif;
            newTradingDataDict.tif = this.tif;
            updated = true;
        }
        if ('cash' in tradingDataDict) {
            this.cash = tradingDataDict.cash;
            newTradingDataDict.cash = this.cash;
            updated = true;
        }
        if ('isCashQtyMode' in tradingDataDict) {
            this.isCashQtyMode = tradingDataDict.isCashQtyMode;
            newTradingDataDict.isCashQtyMode = this.isCashQtyMode;
            updated = true;
        }
        if ('estQtyValue' in tradingDataDict) {
            this.estQtyValue = tradingDataDict.estQtyValue;
            newTradingDataDict.estQtyValue = this.estQtyValue;
            updated = true;
        }
        if ('quantity' in tradingDataDict) {
            this.quantity = tradingDataDict.quantity;
            newTradingDataDict.quantity = this.quantity;
            updated = true;
        }
        if ('placedFrom' in tradingDataDict) {
            this.placedFrom = tradingDataDict.placedFrom;
            newTradingDataDict.placedFrom = this.placedFrom;
            updated = true;
        }
        if ('productType' in tradingDataDict) {
            this.productType = tradingDataDict.productType;
            newTradingDataDict.productType = this.productType;
            updated = true;
        }
        if ('leverageValue' in tradingDataDict) {
            this.leverageValue = tradingDataDict.leverageValue;
            newTradingDataDict.leverageValue = this.leverageValue;
            updated = true;
        }
        if ('disclosedQuantity' in tradingDataDict) {
            this.disclosedQuantity = tradingDataDict.disclosedQuantity;
            newTradingDataDict.disclosedQuantity = this.disclosedQuantity;
            updated = true;
        }
        if ('positionSizingChecked' in tradingDataDict) {
            const pS = this.positionSizing;
            pS.isVisible = tradingDataDict.positionSizingChecked;
            newTradingDataDict.positionSizingChecked = pS.isVisible;
            updated = true;
        }
        if ('comment' in tradingDataDict) {
            this.comment = tradingDataDict.comment;
            newTradingDataDict.comment = this.comment;
            updated = true;
        }
        if ('userComment' in tradingDataDict) {
            this.userComment = tradingDataDict.userComment;
            newTradingDataDict.userComment = this.userComment;
            updated = true;
        }
        if ('isAllowOTHTrading' in tradingDataDict) {
            this.isAllowOTHTrading = tradingDataDict.isAllowOTHTrading;
            newTradingDataDict.isAllowOTHTrading = this.isAllowOTHTrading;
            updated = true;
        }
        this.resetConfirmationMarginFields();
        return updated ? newTradingDataDict : null;
    }
    resetConfirmationMarginFields() {
        if (!this.account) {
            return;
        }
        const dc = this.account.DataCache;
        if (dc.isAllowedForMyUser(RulesSet.FUNCTION_DISPLAY_FEES_ON_CONFIRMATIONS)) {
            this.totalFee = undefined;
        }
        if (dc.isAllowedForMyUser(RulesSet.LEVERAGE_USAGE_WARN)) {
            this.estAvailableCash = undefined;
        }
    }
    // TODO. IMPORTANT. Refactor. setTradingData() - i don't like it.
    // Details are at the top of the file.
    // IMPORTANT. The only method for a consistent object update.
    updateParameters(orderEditUpdateData) {
        const newTradingDataDict = this.setTradingData(orderEditUpdateData.tradingDataDict);
        const sessChanged = orderEditUpdateData.sessionSettingsChanged;
        const newQuoteReceived = newTradingDataDict && 'quote' in newTradingDataDict;
        const dpDict = orderEditUpdateData.dpDict;
        // TODO. Refactor. Why only these fields? Rename variable.
        let validate = !!(newTradingDataDict || sessChanged || newQuoteReceived);
        const updatedParameterNameSet = {};
        for (const paramName in this.parameterNameSet) {
            const dp = dpDict ? dpDict[paramName] : null;
            const paramData = dp || validate
                ? new OrderEditUpdateData({ paramName: dp }, newTradingDataDict, sessChanged, orderEditUpdateData.placedFrom)
                : null;
            if (paramData && this.updateParameter(paramName, paramData)) {
                updatedParameterNameSet[paramName] = true;
                validate = true;
            }
        }
        // Nothing has changed - skipping validation step.
        if (!validate)
            return;
        // Merging updated parameters' names after validation.
        for (const paramName in this.validateParameters()) {
            updatedParameterNameSet[paramName] = true;
        }
        updatedParameterNameSet[OrderEditBaseUtils.SLTP_PARAM] = true;
        // Sending updates back to subscribers.
        const updatedParameterDict = {};
        for (const paramName in updatedParameterNameSet) {
            updatedParameterDict[paramName] = this.createDynPropertyFromParameter(paramName);
            if (updatedParameterDict[paramName].Intervals === undefined) {
                const intervals = Intervals.GetIntervalsFromInstrument(this.instrument, NumericUtils.MAXVALUE);
                if (intervals) {
                    updatedParameterDict[paramName].Intervals = intervals;
                }
            }
        }
        this.ParametersChanged.Raise(updatedParameterDict);
        this.tryUpdateValidState();
    }
    tryUpdateValidState() {
        const newOrderEditValid = this.valid();
        const newOrderEditValidSLTP = this.validSLTP();
        // if (this.account.AccountType !== AccountType.MultiAssetu)
        //     newOrderEditValid = newOrderEditValid && newOrderEditValidSLTP;
        if (this.orderEditValid === null || this.orderEditValid !== (newOrderEditValid && newOrderEditValidSLTP)) {
            this.orderEditValid = newOrderEditValid && newOrderEditValidSLTP;
            this.ValidStateChanged.Raise(this.orderEditValid);
        }
    }
    updateParameter(paramName, paramUpdateData) {
        return this.parameterUpdateHandlerDict[paramName].call(this, paramUpdateData);
    }
    createDynPropertyFromParameter(paramName) {
        var _a;
        const dp = (_a = this.parameterDynPropertyGeneratorDict[paramName]) === null || _a === void 0 ? void 0 : _a.call(this);
        if (!dp) {
            return null;
        }
        dp.name = paramName;
        if (!this.skipParamForFlashing(paramName)) {
            dp.customCSS = this.customCSS;
        }
        return dp;
    }
    // TODO. Refactor. Rename?
    getParameterRawValue(paramName) {
        return this.parameterRawValueGeneratorDict[paramName].call(this);
    }
    // Returns a set of updated parameters' names after validation.
    // TODO. Rename? I'm not sure "validate" is a right word.
    // Method is supposed to check and fix relationships
    // between parameters and trading data
    // ONCE PARAMETERS ARE IN AN UPDATED/ACTUAL STATE.
    // It's more like a second pass, ultimate update ALL parameters call once again.
    validateParameters() {
        return {};
    }
    getParameterNameSet() {
        const paramNameArr = this.getParameterNameArray();
        const paramNameSet = {};
        for (let i = 0, len = paramNameArr.length; i < len; i++) {
            paramNameSet[paramNameArr[i]] = true;
        }
        return paramNameSet;
    }
    getParameterNameArray() {
        throw new Error('Not implemented.');
    }
    // TODO. Refactor. Same as OrderTypeBase.Id function.
    getOrderTypeId() {
        throw new Error('Not implemented.');
    }
    getOrderTypeIdValidation() {
        return this.getOrderTypeId();
    }
    getConfirmationData() {
        return __awaiter(this, arguments, void 0, function* (sendMarginRequest = true) {
            var _a;
            const data = new OrderEditConfirmationData();
            data.text = yield this.getConfirmationText(sendMarginRequest);
            data.text += (_a = this.account) === null || _a === void 0 ? void 0 : _a.GetCommissionInfo(this.instrument); // #111865
            data.warningArray = this.getWarningArray();
            data.needShowWarningForce = this.needToShowWarningForcefully(); // проверяем есть ли там такие ворнинги, что должны игнорировать откл.настройку "Warn if wrong order" и отображать предупреждение #110331
            return data;
        });
    }
    getConfirmationWarningData() {
        const data = new OrderEditConfirmationData();
        data.warningArray = this.getWarningArray();
        data.needShowWarningForce = this.needToShowWarningForcefully();
        return data;
    }
    getWarningArray() {
        return this.warningsManager.getWarningArray();
    }
    getWarningNumeric() {
        return this.warningsManager.getWarningNumeric();
    }
    needToShowWarningForcefully() {
        return this.warningsManager.needToShowWarningForcefully();
    }
    ConfirmationMarginRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            const orderMarginParameters = this.getOrderConfirmationMarginInfoParameters();
            const marginInfo = yield getConfirmationMarginInfoAsync(orderMarginParameters);
            this.lastMarginResponse = marginInfo.marginResponse;
            this.totalFee = marginInfo.totalFee;
            this.estAvailableCash = marginInfo.estAvailableCash;
            this.warningsManager.setOffmarketEnabledWarning(marginInfo.offMarketError);
            if (isValidNumber(this.estAvailableCash)) {
                this.warningsManager.setAfterTradeWarning();
            }
        });
    }
    getOrderConfirmationMarginInfoParameters() {
        const requestdata = this.getDataForRequest();
        return [{ isOnlyOffMarket: false, marginInfoParameters: requestdata.GetMarginParameters() }];
    }
    update_estAvailableCash() { }
    toDynProperty_estAvailableCash() {
        return new DynProperty();
    }
    toRawValue_estAvailableCash() { }
    update_offmarketEnabled() { }
    toDynProperty_offmarketEnabled() {
        return new DynProperty();
    }
    toRawValue_offmarketEnabled() { }
    getConfirmationText() {
        return __awaiter(this, arguments, void 0, function* (sendMarginRequest = true) {
            if (sendMarginRequest)
                yield this.ConfirmationMarginRequest();
            return OrderExecutorUtils.buildOrderEditConfirmationText(this.createConfirmationTextParams());
        });
    }
    getConfirmationParams() {
        return __awaiter(this, arguments, void 0, function* (sendMarginRequest = true) {
            return yield this.getConfirmationText(sendMarginRequest);
        });
    }
    createConfirmationTextParams() {
        const textParams = new OrderEditConfirmationTextParams();
        textParams.Tif = this.tif;
        textParams.Account = this.account;
        textParams.Instrument = this.instrument;
        textParams.Quantity = this.quantity;
        textParams.Cash = this.cash;
        textParams.IsCashMode = this.isCashQtyMode;
        textParams.Buy = this.buy();
        textParams.SlTpText = this.sltp.getConfirmationText(this.getTradingData());
        textParams.ProductType = this.productType;
        textParams.LeverageValue = this.getLeverageValue();
        textParams.IsAllowOTHTrading = this.isAllowOTHTrading;
        textParams.PlacedFrom = this.placedFrom;
        textParams.TotalFee = this.totalFee;
        textParams.EstAvailableCash = this.estAvailableCash;
        return textParams;
    }
    isPosition() {
        return false;
    }
    // Combine with tradingAllowed()?
    valid() {
        return (!TradingLockUtils.TradingLock.tradingLocked &&
            this.tradingAllowed() &&
            Object.keys(this.errorDict).length === 0);
    }
    validSLTP() {
        return this.sltp ? this.sltp.valid() : false;
    }
    getRawSLTP() {
        return this.sltp.getRawValue(this.getTradingData());
    }
    getLeverageValue() {
        return this.leverageValue;
    }
    // TODO.
    tradingAllowed() {
        const acc = this.account;
        const ins = this.instrument;
        if (!acc || !ins) {
            return false;
        }
        return IsAllowed.IsTradingAllowed(acc, ins, this.getOrderTypeIdValidation()).Allowed;
    }
    // error: null - removes error.
    // returns true - if error is new/changed/removed.
    setParameterError(paramName, error) {
        const errorDict = this.errorDict;
        const oldError = errorDict.hasOwnProperty(paramName) ? errorDict[paramName] : null;
        if (error === oldError) {
            return false;
        }
        if (error === null) {
            delete errorDict[paramName];
        }
        else {
            errorDict[paramName] = error;
        }
        return true;
    }
    getParameterError(paramName) {
        return this.errorDict[paramName] || null;
    }
    getBaseCopyInJson() {
        const baseOrderEditObj = {
            account: this.account ? this.account.AcctNumber : null,
            instrument: this.instrument ? this.instrument.GetInteriorID() : null,
            orderType: this.getOrderTypeId(),
            side: this.side,
            cash: this.cash,
            quantity: this.quantity,
            comment: this.comment,
            userComment: this.userComment,
            isAllowOTHTrading: this.isAllowOTHTrading
        };
        return JSON.stringify(baseOrderEditObj);
    }
    createDynPropertyArrayFromParameters() {
        return this.parameterNameArray.map((paramName) => this.createDynPropertyFromParameter(paramName));
    }
    // TODO. Rename.
    getDataForRequest() {
        var _a;
        const res = new OrderEditRequestData();
        res.orderTypeId = this.getOrderTypeId();
        res.instrument = this.instrument;
        res.account = this.account;
        res.quote = this.quote;
        res.side = this.side;
        res.tif = this.tif;
        res.isCashMode = this.isCashQtyMode;
        res.cash = this.cash;
        res.quantity = this.quantity;
        res.parameterDict = this.getRawValueDictFromParameters();
        res.placedFrom = this.placedFrom;
        res.productType = this.productType;
        res.leverageValue = this.leverageValue;
        // if (OrderEditBase.isDisclosedQuantityNeed(res.instrument, res.orderTypeId, res.tif)) {
        res.disclosedQuantity = (_a = this.disclosedQuantity) !== null && _a !== void 0 ? _a : this.quantity;
        // }
        res.comment = this.comment;
        res.userComment = this.userComment;
        res.isAllowOTHTrading = this.isAllowOTHTrading;
        res.totalFee = this.totalFee;
        res.estAvailableCash = this.estAvailableCash;
        return res;
    }
    // <parameter name, parameter value>
    getRawValueDictFromParameters() {
        const resDict = {};
        for (const paramName in this.parameterNameSet) {
            resDict[paramName] = this.getParameterRawValue(paramName);
        }
        return resDict;
    }
    sessionSettingsChanged() {
        if (this.skipSessionSettingsChanged) {
            this.skipSessionSettingsChanged = false;
            return;
        }
        this.updateParameters(new OrderEditUpdateData(null, null, true));
    }
    // #region Quote
    // TODO. Refactor. Details are at the top of the file.
    newQuote(quote) {
        if (quote && quote.Type === HistoryType.QUOTE_INSTRUMENT_DAY_BAR) {
            return;
        }
        this.updateParameters(new OrderEditUpdateData(null, { quote }, false));
    }
    // TODO. Refactor.
    subscribeQuotes(instrument) {
        if (isNullOrUndefined(instrument))
            return;
        this.quoteCache.addListener(instrument, this, HistoryType.QUOTE_LEVEL1);
    }
    // TODO. Refactor.
    unsubscribeQuotes(instrument) {
        if (isNullOrUndefined(instrument))
            return;
        this.quoteCache.removeListener(instrument, this, HistoryType.QUOTE_LEVEL1);
    }
    // #endregion Quote
    buy() {
        return this.side === OperationType.Buy;
    }
    // TODO. Refactor.
    getTradingData() {
        let cash = this.cash;
        let quantity = this.quantity;
        if (this.isCashQtyMode) {
            if (this.estQtyValue != null) {
                quantity = new Quantity(this.estQtyValue, true);
            }
        }
        else {
            cash = null;
        } // #124063
        return {
            instrument: this.instrument,
            account: this.account,
            quote: this.quote,
            side: this.side,
            tif: this.tif,
            cash,
            quantity,
            sessionSettings: this.sessionSettings,
            limitPrice: this.limitPrice,
            stopPrice: this.stopPrice,
            trailingStop: this.trailingStop,
            disclosedQuantity: this.disclosedQuantity,
            leverageValue: this.leverageValue,
            productType: this.productType,
            OrderType: this.getOrderTypeId(),
            comment: this.comment,
            isPosition: this.isPosition(),
            userComment: this.userComment,
            isAllowOTHTrading: this.isAllowOTHTrading
        };
    }
    // Ugly.
    fireParameterChanged(paramName) {
        const dp = this.createDynPropertyFromParameter(paramName);
        if (!dp)
            return;
        const dict = {};
        dict[paramName] = dp;
        this.ParametersChanged.Raise(dict);
    }
    setBreakevenPrice(price) {
        // вызывается при нажатии на стрелочку-кнопку QuotePricePicker a.k.a Breakeven
        this.setBasePrice(price);
    }
    getLimitPriceWithDefaultOffset(price, forceIsBuy = undefined) {
        // forceIsBuy - for OCOCustomOrdersEdit
        const ins = this.instrument;
        const isBuy = forceIsBuy !== null && forceIsBuy !== void 0 ? forceIsBuy : this.buy();
        const sign = isBuy ? 1 : -1;
        return isNullOrUndefined(ins)
            ? undefined
            : ins.calculatePrice(price, sign * BaseSettings.limitOffsetTicks, true);
    }
    onUpdateAccount(acc) {
        const posSizing = this.positionSizing;
        if (!(posSizing === null || posSizing === void 0 ? void 0 : posSizing.isVisible)) {
            return;
        }
        this.recalcQtyForPositionSizing();
        this.updateParameters(posSizing.getAvailableFundsUpdateData()); // #100986
    }
    //                  POSITION SIZING REGION
    update_positionSizing(updateData) {
        const updated = this.positionSizing.update(updateData);
        if (updated) {
            this.recalcQtyForPositionSizing();
        }
        return updated;
    }
    recalcQtyForPositionSizing() {
        const trData = this.getTradingData();
        const isBuy = trData.side === OperationType.Buy;
        const qty = trData ? trData.quantity : null;
        const price = this.getBasePrice();
        const sltp = this.sltp;
        if (qty && sltp) {
            const sl = sltp.sl;
            let slPrice = 0;
            let offsetType;
            if (sltp.useTrailingStop()) {
                slPrice = sltp.trailingStop.value;
                offsetType = sltp.trailingStop.offsetType;
            }
            else if (sl) {
                slPrice = sl.value;
                offsetType = sl.offsetType;
                if (BaseSettings.isUseStopLimitInsteadStop()) {
                    slPrice = offsetType != null ? sl.value + sl.sllValue : sl.sllValue;
                }
            }
            const newQtyValue = this.positionSizing.calculateQty(price, slPrice, qty.inLots, isBuy, offsetType, this.getOrderTypeId() === OrderType.Market, this.getOrderTypeId() === OrderType.TrailingStop);
            if (newQtyValue !== null && MathUtils.TruncateDouble(newQtyValue, 2) !== qty.value) {
                this.QuantityChanged.Raise(newQtyValue);
            }
        }
    }
    toDynProperty_positionSizing() {
        return this.positionSizing.getDynProperty();
    }
    toRawValue_positionSizing() {
        return this.positionSizing.getRawValue();
    }
    toDynProperty_sltp() {
        return this.sltp.getDynProperty(this.getTradingData());
    }
    toRawValue_sltp() {
        return this.sltp.getRawValue(this.getTradingData());
    }
    update_sltp(updateData) {
        return this.sltp.update(updateData, this.getTradingData());
    }
    setSLForcedState(checked) {
        // принудительно включить SL (например при включении positionSizing)
        const sltp = this.sltp;
        if (!sltp)
            return;
        sltp.setSLForcedState(checked);
        this.fireParameterChanged(OrderEditBaseUtils.SLTP_PARAM);
    }
    skipParamForFlashing(paramName) {
        // при включенном positionSizing надо ли DynPropertyControl c paramName пропускать при подсветке лейблов (к примеру как Stop price не подсвечиваем у Stop limit-a)
        return false;
    }
    Copy() {
        const dc = this.instrument.DataCache;
        const type = dc.OrderParameterContainer.GetOrderType(this.getOrderTypeId());
        const newobj = type.createOrderEditObject({ dataCache: dc });
        newobj.setTradingData(this.getTradingData());
        Object.assign(newobj, this);
        return newobj;
    }
    setSLTP(iSlTpEditParams) {
        this.sltp.sltpHolder = iSlTpEditParams.sltpHolder;
        const dp = this.sltp.createDynPropertyForRawSLTP(iSlTpEditParams, this.getTradingData());
        this.updateParameters(new OrderEditUpdateData({ sltp: dp }));
    }
    getEstOrExactQuantity() {
        let result = this.quantity;
        if (this.isCashQtyMode) {
            result = new Quantity(this.estQtyValue, true);
        }
        return result;
    }
    setBoundTo(boundTo) {
        const dp = this.createDynPropertyFromParameter(OrderEditBaseUtils.BOUNDTO);
        dp.value = boundTo;
        this.updateParameters(new OrderEditUpdateData({ boundTo: dp }));
    }
}
export var NumericLinks;
(function (NumericLinks) {
    NumericLinks["LimitPrice"] = "PriceNumericLink";
    NumericLinks["StopPrice"] = "StopPriceNumericLink";
    NumericLinks["Quantity"] = "QNumericLink";
    NumericLinks["StopLoss"] = "SLNumericLink";
    NumericLinks["TakeProfit"] = "TPNumericLink";
    NumericLinks["ProductType"] = "MQNumericLink";
})(NumericLinks || (NumericLinks = {}));
class OrderEditConfirmationData {
    constructor() {
        this.text = null;
        this.warningArray = null;
        this.needShowWarningForce = false;
    }
}
